export const getPostcodeFormat = (postcodeField) => {
  if (!postcodeField) return '';

  let result = postcodeField.toUpperCase().replace(/\s+/g, '').trim();

  if (result.length === 5) {
    result =
      result.replace(/\s+/g, '').trim().substr(0, 2) +
      ' ' +
      result.replace(/\s+/g, '').trim().substr(2, 5);
  } else if (result.length === 6) {
    result =
      result.replace(/\s+/g, '').trim().substr(0, 3) +
      ' ' +
      result.replace(/\s+/g, '').trim().substr(3, 6);
  } else if (result.length >= 7) {
    result =
      result.replace(/\s+/g, '').trim().substr(0, 4) +
      ' ' +
      result.replace(/\s+/g, '').trim().substr(4, 20);
  }

  return result;
};
